import React, { useState } from 'react';
import { buscarCep } from '../../../services/cep';
import { mascararCep, soDigitos } from '../../../utils/documento';
import styles from './Emitir.module.css';

/* Item 12 da lista de serviços (diversão, lazer, entretenimento, eventos):
   a Receita exige o grupo Atividade/Evento -- nome, período e endereço de
   onde aconteceu (erro E0390 sem ele). Só aparece pra esse item. */
export const exigeEvento = (ctn) => String(ctn || '').replace(/\D/g, '').startsWith('12');

export function pendenciasEvento(dados) {
  if (!exigeEvento(dados.codigoTributacaoNacional)) return [];
  const falta = [];
  if (!String(dados.eventoNome || '').trim()) falta.push('nome do evento');
  if (!dados.eventoInicio || !dados.eventoFim) falta.push('período do evento');
  if (soDigitos(dados.eventoCep).length !== 8 || !String(dados.eventoLogradouro || '').trim()
    || !String(dados.eventoNumero || '').trim() || !String(dados.eventoBairro || '').trim()) falta.push('endereço do evento');
  return falta;
}

function EventoServico({ dados, set }) {
  const [msg, setMsg] = useState('');

  async function digitarCep(valor) {
    const d = soDigitos(valor).slice(0, 8);
    const antes = soDigitos(dados.eventoCep);
    set('eventoCep', d);
    if (d.length !== 8 || d === antes) return;
    try {
      const e = await buscarCep(d);
      if (e.logradouro) set('eventoLogradouro', e.logradouro);
      if (e.bairro) set('eventoBairro', e.bairro);
      setMsg('');
    } catch {
      setMsg('CEP não encontrado -- preencha o endereço à mão.');
    }
  }

  function usarTomador() {
    set('eventoCep', soDigitos(dados.tomadorCep));
    set('eventoLogradouro', dados.tomadorLogradouro || '');
    set('eventoNumero', dados.tomadorNumero || '');
    set('eventoComplemento', dados.tomadorComplemento || '');
    set('eventoBairro', dados.tomadorBairro || '');
  }

  return (
    <div style={{ marginTop: 14, padding: 12, border: '1px solid #e4edf5', borderRadius: 10, background: '#fafcff' }}>
      <p className={styles.rotulo} style={{ fontWeight: 800, marginBottom: 2 }}>Atividade / Evento (obrigatório no item 12)</p>
      <p className={styles.dica} style={{ marginTop: 0 }}>A Receita exige o nome, o período e o endereço onde o evento aconteceu.</p>
      <div className={styles.grade}>
        <div className={styles.campo} style={{ gridColumn: '1 / -1' }}>
          <span className={styles.rotulo}>Nome / descrição do evento *</span>
          <input className={styles.entrada} maxLength={255} value={dados.eventoNome || ''} onChange={e => set('eventoNome', e.target.value)} />
        </div>
        <div className={styles.campo}>
          <span className={styles.rotulo}>Início *</span>
          <input type="date" className={`${styles.entrada} ${styles.entradaCurta}`} value={dados.eventoInicio || ''} onChange={e => set('eventoInicio', e.target.value)} />
        </div>
        <div className={styles.campo}>
          <span className={styles.rotulo}>Fim *</span>
          <input type="date" className={`${styles.entrada} ${styles.entradaCurta}`} value={dados.eventoFim || ''} onChange={e => set('eventoFim', e.target.value)} />
        </div>
        <div className={styles.campo}>
          <span className={styles.rotulo}>CEP *</span>
          <input className={`${styles.entrada} ${styles.entradaCurta}`} inputMode="numeric" placeholder="00000-000"
            value={mascararCep(dados.eventoCep)} onChange={e => digitarCep(e.target.value)} />
        </div>
        <div className={styles.campo}>
          <span className={styles.rotulo}>Logradouro *</span>
          <input className={styles.entrada} maxLength={255} value={dados.eventoLogradouro || ''} onChange={e => set('eventoLogradouro', e.target.value)} />
        </div>
        <div className={styles.campo}>
          <span className={styles.rotulo}>Número *</span>
          <input className={`${styles.entrada} ${styles.entradaCurta}`} maxLength={60} value={dados.eventoNumero || ''} onChange={e => set('eventoNumero', e.target.value)} />
        </div>
        <div className={styles.campo}>
          <span className={styles.rotulo}>Complemento</span>
          <input className={styles.entrada} maxLength={156} value={dados.eventoComplemento || ''} onChange={e => set('eventoComplemento', e.target.value)} />
        </div>
        <div className={styles.campo}>
          <span className={styles.rotulo}>Bairro *</span>
          <input className={styles.entrada} maxLength={60} value={dados.eventoBairro || ''} onChange={e => set('eventoBairro', e.target.value)} />
        </div>
      </div>
      {msg && <p className={styles.dica}>{msg}</p>}
      {dados.tomadorLogradouro && (
        <button type="button" className={styles.btnSecundario} style={{ marginTop: 8 }} onClick={usarTomador}>
          Usar o endereço do tomador
        </button>
      )}
    </div>
  );
}

export default EventoServico;
